var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('transition',{attrs:{"name":"slide-left","mode":"out-in"}},[_c('router-view')],1)],1),(_vm.$route.path != '/login' && _vm.$route.path != '/404')?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }